export default function spaceremover(input){
return input.replaceAll(/\s/g,'');

}